module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Text/Quote#2-6efa0db224222c627336b8cf09a30c1f.svg";